/******************************************************************
 * Common tools code
 *****************************************************************/
var Unclick = require('./unclick.js');
var moment = require('moment');
var Common = {};
const defaultDecimalPlaces = 2;

/**
 * Export common function
 */
module.exports = (function () {
    //search-panel-with-btn click action in complexSelectList
    Common.searchPanelBtnClick = function (btn, applyText) {
        //replace select panel's text
        var titleElement = $(btn).parents('.panel-selectlist-complex').find('> .cus-dropdown-btn > .panel-title-section');
        if (titleElement && titleElement.length === 1) {
            titleElement.empty();
            titleElement.append('<span>' + applyText + '</span>');
        }

        $(btn).parents('.search-panel-with-btn').collapse('hide');
    }

    Common.convertByteSize = function (size) {
        var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'],
            unitIndex = 0;
        
        while (size >= 1024) {
            size = size / 1024;
            unitIndex++;
        }

        return Math.round(size) + " " + units[unitIndex];
    }

    return Common;
})();

/**
 * Same reference for payee feature
 */
$(function () {
    function copyText(scope) {
        var sourceValue = $(scope).parents('.same-refer-container').find('.same-refer-source').val();
        if (sourceValue) {
            var dest = $(scope).parents('.same-refer-container').find('.same-refer-dest');
            if (dest && dest.length) {
                var maxLen = dest.attr("maxlength");
                sourceValue = sourceValue.substr(0, maxLen);
                dest.val(sourceValue);
            }
        }
    }

    $('.same-refer-switcher .label-yes').click(function () {
        copyText(this);
    });

    $('.same-refer-switcher .label-no').click(function () {
        $(this).parents('.same-refer-container').find('.same-refer-dest').val('');
    });

    $('.same-refer-source').change(function () {
        if ($(this).parents('.same-refer-container').find('.same-refer-switcher .label-yes').hasClass('active') === true) {
            copyText(this);
        }
    });

    $('.same-refer-dest').keyup(function () {
        let valueSource = $(this).parents('.same-refer-container').find('.same-refer-source').val();
        let valueDest = $(this).parents('.same-refer-container').find('.same-refer-dest').val();
        if (valueSource !== valueDest) {
            let $switcher = $(this).parents('.same-refer-container').find('.same-refer-switcher');
            if ($switcher.length === 1) {
                $switcher.find('.btn').removeClass('active');
                $switcher.find('.label-no').addClass('active');
                $switcher.find('.label-no input').prop('checked', true);
            }
        }
    });
});

/**
 * Hide search list that is not in a panel
 */
$(function () {
    function hideList() {
        $(this).addClass('d-none');
        $(this).parents('.search-input-with-btn-container').removeClass('search-list-open');
    }
    
    var elements = $('.search-input-with-btn-container .search-input-with-btn-list');

    var exceptArray = [];
    for (var i = 0; i < elements.length; i++) {
        var input = $(elements[i]).parents('.search-input-with-btn-container').find('.search-input-not-in-panel'),
            btn = $(elements[i]).parents('.search-input-with-btn-container').find('button'),
            eleObj = {
                elem: elements[i],
                excepts: []
            };

        if (input && input.length) {
            input.each(function (index, element) {
                eleObj.excepts.push($(element).parents('.input-group')[0]);
            });
        }

        if (btn && btn.length) {
            btn.each(function (index) {
                eleObj.excepts.push(btn[index]);
            });
        }

        exceptArray.push(eleObj);

        Unclick.registerUnclick(elements[i], hideList, exceptArray);
    }
});

/*
 * close panel-selectlist when click on outside
 */
$(function () {
    var dd_panelBody = $('.panel-selectlist .collapse-under-btn.collapse');

    function closePanel() {
        $(this).collapse('hide');
    }

    for (var i = 0; i < dd_panelBody.length; i++) {
        Unclick.registerUnclick(dd_panelBody[i], closePanel);
    }
});

/*
 * process a panel with a group list that can be selected, select item text will apply panel heading
 */
$(function () {
    //simple
    $(document).on('click.simpleSelectList', '.panel-selectlist .list-group-item', function () {
        var clickText = $(this).text();
        var panelTitleEle = $(this).parents('.panel-selectlist').find('> .cus-dropdown-btn > .panel-title');
        var curText = panelTitleEle.text();
        if (curText !== clickText) {
            panelTitleEle.text(clickText);
        }
        $($(this).parents('.collapse')[0]).collapse('hide');
        $($(this).parents('.panel-selectlist')[0]).find('.list-group-item').removeClass('active');
        $(this).addClass('active');
    });

    //complex
    $(document).on('click.complexSelectList', '.panel-selectlist-complex .list-group-item', function () {
        var clickElements = $(this).children();
        var panelTitleEle = $(this).parents('.panel-selectlist-complex').find('.panel-title-section');

        panelTitleEle.empty();
        panelTitleEle.append(clickElements.clone());
        $($(this).parents('.collapse')[0]).collapse('hide');
        $($(this).parents('.panel-selectlist-complex')[0]).find('.list-group-item').removeClass('active');
        $(this).addClass('active');
    });
});

/*
 * Init bootstrap validator
 */
$(function () {
    $('form').validator({
        custom: {
            "date-validate": function (elem) {
                var m = moment(elem.val(), window.MvpFE.globalConfiguration.momentExpectFormatGroups || ['DD/MM/YYYY', 'DD MMM YYYY', 'DD MM YYYY'], true);
                if (!m.isValid()) {
                    return window.MvpFE.globalConfiguration.dateValidateMessage || "Not a valid date (Choose DD/MM/YYYY or DD MMM YYYY)";
                }
            },
            "amount-validate": function (elem) {
                var value = elem.val().trim().replace(/,/g, '');
                var num = Number(value);
                if (isNaN(num) || num < 0) {
                    return "Not a valid amount";
                } else {
                    var pos = value.indexOf('.');
                    if (pos === -1) {
                        return;
                    }
                    
                    var decimal = value.substr(pos + 1),
                        decimalPlaces = elem.data('decimal-places');

                    decimalPlaces = decimalPlaces || defaultDecimalPlaces;
                    if (decimal.length > decimalPlaces) {
                        return "Not a valid amount";
                    }
                }
            },
            "range-validate": function(elem) {
                var val = elem.val();
                val = val.replace(/,/g, '');
                val = parseFloat(val);
                var min = parseFloat(elem.attr('data-min'));
                var max = parseFloat(elem.attr('data-max'));

                if (val < min) {
                    return "Value must be greater than or equal to " + addComma(min);
                }
                if (val > max) {
                    return "Value must be less than or equal to " + addComma(max);
                }
            },
            //This is for date of birth in Online Leading now
            "date-age-min": function(elem) {
                let m = moment(elem.val(), window.MvpFE.globalConfiguration.momentExpectFormatGroups || ['DD/MM/YYYY', 'DD MMM YYYY', 'DD MM YYYY'], true);
                if (m.isValid()) {
                    let age = $(elem).data("date-age-min");
                    let yearNow = new Date().getFullYear();
                    let yearDob = new Date($(elem).val()).getFullYear();
                    if (yearNow - yearDob < age) {
                        return `The applicant must be ${age} years of age or over.`;
                    }
                }
            }
        },
        delay: 1000
    });
    //This setting has some issue now and some input filed cannot bind event like amount filed
    //$.fn.validator.Constructor.INPUT_SELECTOR += ':visible';
    //$('form').validator('update');

    //update validator to don't submit hidden fields when tab switch
    $('form [data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        $('form').validator('update');
    });

    function updateValidator() {
        $('form').validator('update');
    }
    window.MvpFE.rebindFunctions.updateValidator = updateValidator;
});

/*
 * Select an select option to show specific panel and hidden others
 */
$(function () {
    $('.ref-panel').change(function () {
        var panelId = $(this).find(':selected').data('refpanelid');
        $('.ref-select-option').addClass('d-none');
        $('#' + panelId).removeClass('d-none');
    });
});

/* 
 * process close icon
 */
$(function () {
    $('.close-icon').click(function () {
        var targetId = $(this).data('closeid');
        $('#' + targetId).hide(400);
    });
});

/*
 * dynamic colspan
 */
$(function () {
    function applyColSpan() {
        var winWidth = $(window).width();
        if (winWidth < 768) {
            $('td[data-mobilespan]').each(function () {
                $(this).attr('colspan', $(this).data('mobilespan'));
            });
        } else {
            $('td[data-desktopspan]').each(function () {
                $(this).attr('colspan', $(this).data('desktopspan'));
            });
        }
    }

    if ($('td[data-mobilespan]').length > 0) {
        $(window).resize(function () {
            applyColSpan();
        });
        applyColSpan();
    }
});

/*
 * clickable row process
 */
$(function () {
    function addAccessibilityAttr() {
        $('.clickable-row, .clickable-row-desktop').attr('tabindex', 0);
        $('.clickable-row').attr('role', 'link');
        if ($(window).width() >= 768) {
            $('.clickable-row-desktop').attr('role', 'link');
        }
    }
    addAccessibilityAttr();
    window.MvpFE.rebindFunctions.addAccessibilityAttr = addAccessibilityAttr;

    function isCusCheckbox(e) {
        if ($(e.target).parents('.checkbox-cus').length > 0) {
            return true;
        }
        return false;
    }

    function isInLink(e) {
        if ($(e.target).hasClass('link-in-clickable-row') || $(e.target).parents('.link-in-clickable-row').length > 0) {
            return true;
        }
        return false;
    }

    $(document).on('click', '.clickable-row', function (e) {
        if (isCusCheckbox(e) || isInLink(e)) {
            return;
        }
        window.location = $(this).data('href');
    });

    $(document).on('click', '.clickable-row-desktop', function (e) {
        if (isCusCheckbox(e) || isInLink(e)) {
            return;
        }
        if ($(window).width() >= 768) {
            window.location = $(this).data('href');
        }
    });

    $(document).on('keyup', '.clickable-row', function (e) {
        if (isCusCheckbox(e) || isInLink(e)) {
            return;
        }

        if (e.which == 13) {
            window.location = $(this).data('href');
        }
    });

    $(document).on('keyup', '.clickable-row-desktop', function (e) {
        if (isCusCheckbox(e) || isInLink(e)) {
            return;
        }

        if ($(window).width() >= 768 && e.which == 13) {
            window.location = $(this).data('href');
        }
    });
});

/*
 * change credit card field's value
 */
$(function () {
    $(document).on('keyup.credit-card-field', '.credit-card-field', function (e) {
        var value = $(this).val().replace(/\s+/g, ''),
            len = value.length;

        if (len > 0 && e.key !== 'Backspace') {
            var newValue = '';
            for (var i = 0; i < len; i++) {
                if (i > 0 && i % 4 === 0) {
                    newValue += ' ';
                }
                newValue += value[i];
            }
            $(this).val(newValue);
        }
    });
});

/*
 * select options tab 
 */
$(function () {
    $(document).on('change.selecttabs', 'select.selecttabs', function () {
        var target = $(this).data('selecttab'),
            index = $(this).prop('selectedIndex'),
            selector = target + ' > li:eq(' + index + ') > a';

        $(selector).tab('show');
    });
});

function addComma(num) {
    var value = num.toString();
    var dotIndex = value.indexOf('.');
    if (dotIndex === -1 || (dotIndex >= value.length - 2 && value.length >= 2)) {
        num = num.toFixed(defaultDecimalPlaces);
    }
    value = num.toString();
    //get index again becuase of toFixed
    dotIndex = value.indexOf('.');
    var amountIntPart = value.slice(0, dotIndex);

    for (var i = amountIntPart.length - 3; i > 0; i -= 3) {
        amountIntPart = value.slice(0, i) + ',' + amountIntPart.slice(i);
    }
    
    value = amountIntPart + value.slice(dotIndex);

    return value;
}
window.MvpFE.addComma = addComma;

/*
 * Amoutn field
 */
$(function () {
    // Automaticly add .00 for account field when user finish the field
    $(document).on('change.amount-auto-format', '.amount-auto-format', function () {
        var value = $(this).val();

        if (value) {
            value = value.replace(/,/g, '');
            var num = Number(value);
            if (!isNaN(num) && num >= 0) {
                value = addComma(num);
                $(this).val(value);
            }
        }
    });

    //Insert data attribute and validation infor box to amount field
    function insertAttrDivToAmount() {
        $('.amount-auto-format').each(function () {
            $(this).attr('data-amount-validate', '');
            var errorBox = $(this).nextAll('.help-block.with-errors');
            if (errorBox.length === 0) {
                $(this).after('<div class="help-block with-errors"></div>');
            }
        })
    }
    insertAttrDivToAmount();
    window.MvpFE.rebindFunctions.insertAttrDivToAmount = insertAttrDivToAmount;
});


/*
 * Scroll to collapse container
 */
$(function () {
    $('.scroll-to-here').on('shown.bs.collapse', function (e) {
        if (!$(this).is(e.target)) return;

        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 500);
    });
});

/**
 * Scroll to target when click the element
 */
$(function() {
    $(document).on('click', '[data-scrollto]', function () {
        var selector = $(this).data('scrollto');
        if (selector && selector.length > 0) {
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $(selector).offset().top
                }, 500);
            }, 10);
        }
    });
});

/*
 * Close window when click this element
 */
$(function () {
    $(document).on('click.closeWindow', '.close-window', function () {
        window.close();
    });
});

/*
 * radio button active init
 */
$(function () {
    function resetRadioActive() {
        var elements = $('[data-cus-toggle="buttons"] > label > input[type="radio"]');
        for (var i = 0; i < elements.length; i++) {
            if ($(elements[i]).prop('checked')) {
                $(elements[i]).parents('[data-cus-toggle="buttons"]').find('label').removeClass('active');
                $(elements[i]).parent().addClass('active');
                // We cannot use tab('show') or show() in bs5 as radio with tab is not supported anymore
                let $tabLabel = $(elements[i]).parent('[data-bs-toggle="tab"]');
                if ($tabLabel.length > 0) {
                    let tabPaneSelector = $tabLabel.data('bs-target');
                    let $tabPane = $(tabPaneSelector);
                    $tabPane.parent('.tab-content').children().removeClass('active show');
                    $tabPane.addClass('active show');
                }
            }
        }
    }
    resetRadioActive();
    window.MvpFE.rebindFunctions.resetRadioActive = resetRadioActive;
});

/**
 * process transfer time radio buttons border radius
 */
$(function () {
    function setTransTimeRadius() {
        $('label[data-bs-target="#transfer_now_tab"]').on('show.bs.tab', function () {
            $(this).parent('.btn-group').removeClass('bottom-radius-zero');
        });
        $('label[data-bs-target="#transfer_onceon_tab"], label[data-bs-target="#transfer_recurring"]').on('show.bs.tab', function () {
            $(this).parent('.btn-group').addClass('bottom-radius-zero');
        });
    }
    setTransTimeRadius();
    window.MvpFE.rebindFunctions.setTransTimeRadius = setTransTimeRadius;
});

/**
 * search input field is not in a panel common action
 */
$(function () {
    $(document).on('focus', '.search-input-with-btn-container .input-group input, .search-panel-with-btn .input-group input', function () {
        $(this).parents(".input-group").addClass("input-focus")
    });

    $(document).on('blur', '.search-input-with-btn-container .input-group input, .search-panel-with-btn .input-group input', function () {
        $(this).parents(".input-group").removeClass('input-focus');
    });
});
/**
 *  map keyboard pressing enter to click event for unsupported elements 
 */
$(function () {
    $(document).on('keypress', 'label[role="button"], a.list-group-item-action', function (e) { 
        if (e.keyCode == 13) { // If the the enter key was pressed.
            $(this).click(); // Trigger the button(elementId) click event.
            return e.preventDefault(); // Prevent the form submit if any.
        } 
    });
});
/**
 * Print page
 */
$(function () {
    $(document).on('click', '.print-page-btn', function () {
        window.print();
    });
});

/**
 * quick links
 */
$(function () {
    function insertMoreOptions (eles, maxNum) {
        if (eles && eles.length > 0) {
            for (var i = eles.length; i >= maxNum - 1; i--) {
                var currEle = eles[i]
                $(currEle).removeClass();
                $(currEle).addClass('list-group-item text-end');
                $(currEle).removeAttr('role');
                $(currEle).parent('.quick-links').siblings('.quick-links-more-options').children('.list-group').prepend(currEle);
            }

            $(eles[0]).siblings('.quick-links-more-option-btn').removeClass('d-none');
        }

    }

    function adjustQuickLinks () {
        //The number of quick links on desktop
        var maxNum = 5,
            maxNumMobile = 3,
            quickLinks = $('.quick-links');

        if (!quickLinks || quickLinks.length === 0) {
            return;
        }

        for (var i = 0; i < quickLinks.length; i++) {
            var links = $(quickLinks[i]).children('a:not(.quick-links-more-option-btn)')
            if (links && links.length > 0) {
                if ($(window).width() >= 768) {
                    if (links.length > maxNum) {
                        insertMoreOptions(links, maxNum);
                    }
                } else {
                    if (links.length > maxNumMobile) {
                        insertMoreOptions(links, maxNumMobile);
                    }
                }
            }
        }
    }

    adjustQuickLinks ();
    window.MvpFE.rebindFunctions.adjustQuickLinks = adjustQuickLinks;
});

/* match height for left title table on tablet*/
$(function () {
    function matchCellHeightTablet () {
        if ($(window).width() < 768 || $(window).width() >= 992) {
            $('.table-title-left-tablet tbody tr td:not(.content-only-nopadding)').css('height', '');
            return;
        }

        var trs = $('.table-title-left-tablet tbody tr');
        if (!trs || trs.length === 0) {
            return;
        }

        for (var i = 0; i < trs.length; i++) {
            var tds = $(trs[i]).children('td:not(.content-only-nopadding)');
            if (!tds || tds.length === 0) {
                continue;
            }

            for (var j = 1; j < tds.length; j += 2) {
                var height1 = $(tds[j - 1]).height();
                var height2 = $(tds[j]).height();
                if (height1 !== height2) {
                    height1 > height2 ? $(tds[j]).height(height1) : $(tds[j - 1]).height(height2);
                }
            }
        }
    }

    matchCellHeightTablet();
    $(window).resize(function () {
        matchCellHeightTablet();
    });
});

// Input file type logic
$(function () {
    function inputFileChange() {
        var inputs = $('.inputfile');
        inputs.each(function (i, input) {
            var btn = $(input).next('.inputfile-btn');
            $(input).change(function() {
                var fileName = $(this).val().split('\\').pop();

                if (fileName) {
                    $(btn).children('.inputfile-btn-text').text(fileName + " (" + Common.convertByteSize(this.files[0].size) + ")");
                }
            });
        });
    }
    inputFileChange();
    window.MvpFE.rebindFunctions.inputFileChange = inputFileChange;
});

// Adjust iframe's height
$(function () {
    $('.iframe-auto-height').on('load', function () {
        $(this).height(this.contentWindow.document.body.scrollHeight);
    });
});

// change phone code select options eg: from "US +1" to "+1 US"
$(function () {
    function updatePhoneCodeOptions () {
        $('.phone-input-areacode select option').each(function() {
            let originText = $(this).text();
            let index = originText.indexOf('+');
            if (index > 0) {
                let newText = originText.substring(index) + ' ' + originText.substring(0, index - 1);
                $(this).text(newText);
            }
        });
    }

    updatePhoneCodeOptions();
    window.MvpFE.rebindFunctions.bindSelectPicker = updatePhoneCodeOptions;
});

// nicEdit
$(function () {
    var editMain = $('.nicEdit-main');
    if (editMain.length > 0) {
        editMain.parent().addClass('nic-edit-main-container');
    }
});

// Checkbox
$(function () {
    // toggle all checkbox
    $(document).on('change', '.checkbox-head', function() {
        $(this).parents('table').find('tbody .checkbox-cus input[type="checkbox"]').prop('checked', this.checked);
    });
});

// rotate iamge
$(function() {
    $('[data-rotate-imageid]').click(function() {
        var targetId = $(this).data('rotate-imageid');
        var ele = $('#' + targetId);
        if (!ele.hasClass('rotate-image')) {
            ele.addClass('rotate-image rotate-image-1');
        } else {
            var className = ele[0].className.match(/rotate-image-(\d)/);
            var newClassName = 'rotate-image-' + ((parseInt(className[1]) % 4) + 1);
            ele.removeClass(className[0]);
            ele.addClass(newClassName);
        }
    })
});

// hack way to insert the value into another row in a confirm container
$(function () {
    $('.confirm-info-box .value-merge-to-previous-row').each(function () {
        var text = $(this).text();
        var prevValueDiv = $(this).parent('.row').prev('.row').children(':last-child');
        if (prevValueDiv.length > 0) {
            prevValueDiv.html(prevValueDiv.html() + '<br />' + text);
            $(this).parent('div').remove();
        }
    });
});

// Binding radio buttons with a list-group together, click radio button will select right list-group-list or vice versa 
$(function () {
    function selectBindingListItem(list, target) {
        const panelTitleEle = $(list).parent('.panel-selectlist').find('.panel-title');
        const listItem = $(list).children(`[href="${target}"]`);
        const text = listItem.text();
        $(list).children('.list-group-item').removeClass('active');
        listItem.addClass('active');
        panelTitleEle.text(text);
    }

    function setBindingListItem() {
        let elements = $('[data-binding-select-list] > label >  input[type=radio]');
        elements.each(function () {
            if ($(this).prop('checked')) {
                const target = $(this).parent().data('bs-target');
                const list = $(this).parents('[data-binding-select-list]').data('binding-select-list');
                selectBindingListItem(list, target);
            }
        });
    }

    setBindingListItem();

    $(document).on('click', '[data-binding-radio-btns="true"] > .list-group-item', function () {
        const target = $(this).attr('href');
        $(`.btn-group label[data-bs-target="${target}"]`).trigger('click');
    });

    $(document).on('click', '[data-binding-select-list] > label', function () {
        const target = $(this).data('bs-target');
        const list = $(this).parent().data('binding-select-list');
        selectBindingListItem(list, target);
    });
});

// Custom Accordion - bootstrap3's accordion needs to use panel, so we create our own
// Don't nest
$(() => {
    function bindCusAccordionClicks() {
        let allCollapses = $('[data-parent-cus]');
        allCollapses.each(function() {
            $(this).on('click', function () {
                if ($(this).attr('aria-expanded') == 'false') {
                    let currEle = this;
                    allCollapses.each(function () {
                        if (currEle !== this) {
                            let targetSelForHide = $(this).data('bs-target');
                            $(targetSelForHide).collapse('hide');
                        }
                    });
                    
                    let me = this;
                    setTimeout(function() {
                        $('html, body').scrollTop($(me).offset().top);
                    }, 400);
                }
            });
        });
    }
    window.MvpFE.rebindFunctions.bindCusAccordionClicks = bindCusAccordionClicks;
    bindCusAccordionClicks();
});

// adjust border radius for cus-dropdown-btn and simlar elements
$(function() {
    $(document).on('show.bs.collapse', '.collapse-under-btn', function(e) {
        if (!$(this).is(e.target)) return;
        $(`[data-bs-target="#${this.id}"]`).addClass('bottom-radius-zero');
    });

    $(document).on('hidden.bs.collapse', '.collapse-under-btn', function(e) {
        if (!$(this).is(e.target)) return;
        $(`[data-bs-target="#${this.id}"]`).removeClass('bottom-radius-zero');
    });
});
    
// Aujust height of td for table-title-left-mobile table
$(function () {
    function adjustTableCellHeight() {
        if ($(window).width() >= 768) return;
        let allTables = $('.table-title-left-mobile.table-match-height-mobile');
        if (allTables.length === 0) return;
        
        allTables.each(function () {
            let allCellsInCurr = $(this).find('tbody tr:not(.online-lending-summary-total-amount-row) td:not(.content-only-nopadding)');
            allCellsInCurr.each(function () {
                let currTitle = $(this).data('title');
                let oldHeight = $(this).height();
                let oldText = $(this).text();
                let oldPaddingLeft = $(this).css('paddingLeft');
                let paddingTop = $(this).css('paddingTop');
                let oldTextTransform = $(this).css('text-transform');
                let headerTransform = $(this).parents('table').find('thead td, thead th').first().css('text-transform');
                paddingTop = paddingTop.substring(0, paddingTop.indexOf('px'))
                $(this).css('padding-left', $(this).width() + paddingTop * 2 + 10);
                $(this).css('text-transform', headerTransform);
                $(this).text(currTitle);
                let newHeight = $(this).height() + paddingTop * 2;
                $(this).css('padding-left', oldPaddingLeft);
                $(this).css('text-transform', oldTextTransform);
                if (newHeight > oldHeight) {
                    $(this).css('height', newHeight);
                }
                $(this).text(oldText);
            });
        });
    }

    adjustTableCellHeight();
    $(window).resize(function() {
        //when the size of window changed, clear the include style and redo the adjustment if it is a small screen device
        let allTables = $('.table-title-left-mobile.table-match-height-mobile');
        if (allTables.length > 0) {
            allTables.each(function () {
                let allCellsInCurr = $(this).find('tbody td:not(.content-only-nopadding)');
                allCellsInCurr.each(function () {
                    $(this).attr('style', '');
                });
            });
        }
        adjustTableCellHeight();
    });
});

// select2 and select2-bs5-theme init
function InitSelect2() {
    $('.mutiple-select').select2({
        theme: "bootstrap-5",
        closeOnSelect: false,
    });
}
window.MvpFE.rebindFunctions.InitSelect2 = InitSelect2;


$(function() {
    InitSelect2();
});